export enum INDICATOR {
  DARK = '#13A6B1',
  LIGHT = '#FF9900',
  BLUR = '#D8D8D8',
  RED = '#C52C07',
}
